import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';

import { theme } from '_constants/theme';
import { hexToRGBA } from '_helpers/theme';

import Spinner from 'components/atomic/Spinner';
import Text from 'components/atomic/layouts/Text';

import BankAccountsListItem from './BankAccountsListItem';

// eslint-disable-next-line react/display-name, react/prop-types, no-unused-vars
const StyledContainer = styled(forwardRef(({ loading, ...props }, ref) => <div ref={ref} {...props} />))`
  max-height: 300px;

  margin-right: ${theme.spaces.large / 2}px;
  margin-bottom: ${theme.spaces.regular}px;
  padding-left: ${theme.spaces.large}px;
  padding-top: ${theme.spaces.medium}px;

  overflow: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: ${hexToRGBA(theme.colors.gray.secondary, 0.1)} 0% 0% no-repeat padding-box;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${hexToRGBA(theme.colors.gray.secondary, 0.5)} 0% 0% no-repeat padding-box;
    border-radius: 4px;
  }

  ${({ loading }) =>
    loading &&
    css`
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      width: 100%;
      overflow: unset;
      overflow-x: unset;
      padding: 0;
      margin: 0;
    `}

  @media ${theme.devices.tablet} {
    max-height: unset;
    overflow: unset;
    overflow-x: unset;

    ${({ loading }) =>
      loading &&
      css`
        margin-bottom: ${theme.spaces.regular}px;
      `}
  }
`;

const BankAccountsList = ({ loading, items = [], onDelete }) => {
  if (!items.length && loading) {
    return (
      <StyledContainer loading>
        <Spinner />
      </StyledContainer>
    );
  }

  if (!items.length) {
    return (
      <StyledContainer loading>
        <Text size={theme.fontSizes.small} weight={400} color={theme.colors.gray.primary} centered>
          No data available
        </Text>
      </StyledContainer>
    );
  }

  return (
    <StyledContainer>
      {items.map((item) => (
        <BankAccountsListItem key={item.id} {...item} onDelete={onDelete} />
      ))}
    </StyledContainer>
  );
};

BankAccountsList.propTypes = {
  loading: PropTypes.bool,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      text: PropTypes.string,
    })
  ),
  onDelete: PropTypes.func,
};

export default BankAccountsList;
